<template>
  <page-view>
    <div class="">
      <a-row :gutter="[16,16]">
        <a-col :span="7">
          <a-card class="zdy_card">
            <template slot="title">
              待审核的申请
              <a-badge :show-zero="true" :count="work.pendingAuditApplyForTaskTotal"/>
            </template>
            <a-button @click="goToUrl(JumpUrl.pendingAuditApplyForTask.moreUrl)" size="small" slot="extra">更多
            </a-button>
            <ul class="index_list">
              <template v-if="work.pendingAuditApplyForTaskBoList.length > 0">
                <li v-for="item in work.pendingAuditApplyForTaskBoList" :key="item.id" @click="onAudit(item)">
                  <a-tag color="#68B775" class="flex_0">{{ ApplyForTypeEnum.getAuditObj(item.applyForType).text }}申请</a-tag>
                  <span class="w_100" :title="item.applyForTitle">{{ item.applyForTitle }}</span>
                  <span class="flex_0 dsg_text1">{{ item.createDate | dayjs('MM-DD HH:mm') }}</span>
                  <a-icon type="right"/>
                </li>
              </template>
              <a-empty v-else/>
            </ul>
          </a-card>
        </a-col>
        <a-col :span="10">
          <a-card class="zdy_card">
            <template slot="title">
              专家请假需补抽的任务
              <a-badge :show-zero="true" :count="work.drawTaskTotal"/>
            </template>
            <a-button @click="goToUrl(JumpUrl.drawTask.moreUrl)" size="small" slot="extra">更多</a-button>
            <ul class="index_list v2">
              <template v-if="work.drawTaskBoList.length > 0">
                <li v-for="item in work.drawTaskBoList" :key="item.id" @click="goToUrl(JumpUrl.drawTask.viewUrl, item.applyId)">
                  <p class="text1" :title="item.projectName">
                    {{ item.projectName }}</p>
                  <p class="text2">{{ item.openDate | dayjs('MM-DD HH:mm') }}</p>
                  <span class="text3">{{ item.leaveNum }}人请假</span>
                </li>
              </template>
              <a-empty v-else/>
            </ul>
          </a-card>
        </a-col>
        <a-col :span="7">
          <a-card class="zdy_card" title="最近开标">
            <a-radio-group size="small" slot="extra" v-model="nearestDateQuery.key" button-style="solid">
              <a-radio-button v-for="item in NearestDateList" :key="item.id" :value="item.value">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
            <ul class="index_list">
              <template v-if="work.nearestExtractTaskList.length > 0">
                <li v-for="item in work.nearestExtractTaskList" :key="item.id"  @click="goToUrl(JumpUrl.nearestExtractTask.viewUrl, item.applyId)">
                <span class="w_100"
                      :title="item.projectName">{{ item.projectName }}</span>
                  <span class="flex_0 dsg_text1">{{ item.openDate | dayjs('MM-DD') }}</span>
                  <a-icon type="right"/>
                </li>
              </template>
              <a-empty v-else/>
            </ul>
          </a-card>
        </a-col>
        <a-col :span="17">
          <a-card class="zdy_card">
            <div slot="title">
              <span class="title">待处理的专家抽取任务</span>
            </div>
            <div style="min-height: 273px;">
              <a-table :pagination="false"
                       :columns="pendingExpertExtractColumns" :data-source="work.pendingExpertExtractTaskBoList"
                       rowKey="applyId">
                <template v-slot:projectName="text,record">
                  <img src="../../assets/icon4.svg" v-if="record.newFlag">
                  <span style="color: #3F8DED">【{{ record.applyType }}】</span>
                  <b>{{ text }}</b>
                </template>
                <template v-slot:action="text,record">
                  <a @click="goToUrl(record.processUserId?JumpUrl.pendingExpertExtractTask.viewUrl:JumpUrl.pendingExpertExtractTask.editUrl, record.applyId)">
                    <template v-if="!record.allExtractNum && !record.recordNum">
                      <span style="color: #EB7070">未开始抽取</span>
                    </template>
                    <template v-else>
                      <span style="color: #EB7070">还需补抽{{ record.expertNumber - record.extractNum }}人</span>
                    </template>
                  </a>
                </template>
              </a-table>
            </div>

          </a-card>
        </a-col>
        <a-col :span="7">
          <a-card class="zdy_card v2">
            <div slot="title">
              <span class="title" style="background: #8DB8FF">已完成抽取未解密</span>
            </div>
            <ul class="index_list v3">
              <template v-if="work.completeUnDecryptTaskBoList.length > 0">
                <li v-for="item in work.completeUnDecryptTaskBoList"
                    :key="item.id"
                    @click="goToUrl(JumpUrl.completeUnDecryptTask.viewUrl,item.applyId)">
                  <p class="text1" :title="item.projectName">
                    {{ item.projectName }}</p>
                  <p class="text2">{{ item.openDate | dayjs('MM-DD HH:mm') }}</p>
                </li>
              </template>
              <a-empty v-else/>
            </ul>
          </a-card>
        </a-col>
      </a-row>
    </div>
    <AuditExpertStorageApplyFor ref="invVisible" @submitSuccess="getWorkViewIndex()"></AuditExpertStorageApplyFor>
    <AuditExpertOutApplyFor ref="outVisible" @submitSuccess="getWorkViewIndex()"></AuditExpertOutApplyFor>
    <AuditExpertEditPurchaseApplyFor ref="itemVisible"  @submitSuccess="getWorkViewIndex()"></AuditExpertEditPurchaseApplyFor>
  </page-view>
</template>
<script>
import { PageView } from '@/layouts'
import { GetWorkViewIndex, NearestExtractTaskList } from '@/views/dashboard/api/WorkPlaceApi'
import {
  JumpUrl,
  NearestDateList,
  pendingExpertExtractColumns
} from '@/views/dashboard/util/WorkPlaceUtil'
import { ApplyForTypeEnum } from '@/epp/expertmain/pendingauditapplyfor/util/ApplyForUtil'
import AuditExpertStorageApplyFor from '@epp/expertmain/pendingauditapplyfor/AuditExpertStorageApplyFor'
import AuditExpertOutApplyFor from '@epp/expertmain/pendingauditapplyfor/AuditExpertOutApplyFor'
import AuditExpertEditPurchaseApplyFor from '@epp/expertmain/pendingauditapplyfor/AuditExpertEditPurchaseApplyFor'

export default {
  name: 'AdminWorkplace',
  computed: {},
  inject: ['reload'],
  components: {
    PageView,
    AuditExpertStorageApplyFor,
    AuditExpertOutApplyFor,
    AuditExpertEditPurchaseApplyFor
  },
  async created () {
    await this.getWorkViewIndex()
    await this.getNearestExtractTaskList()
  },
  data () {
    return {
      ApplyForTypeEnum,
      JumpUrl,
      pendingExpertExtractColumns,
      work: {
        drawTaskBoList: [],
        completeUnDecryptTaskBoList: [],
        nearestExtractTaskList: [],
        pendingExpertExtractTaskBoList: [],
        pendingAuditApplyForTaskBoList: [],
        pendingAuditApplyForTaskTotal: undefined,
        drawTaskTotal: undefined
      },
      //最近任务
      NearestDateList,
      nearestDateQuery: {
        key: NearestDateList[0].value
      },
      //工作台默认分页
      page: {
        pageSize: 5
      }
    }
  },
  watch: {
    'nearestDateQuery.key' (val) {
      this.getNearestExtractTaskList()
    }
  },
  methods: {
    //获取工作台数据
    async getWorkViewIndex () {
      try {
        let res = await GetWorkViewIndex(this.page)
        if (200 !== res.code) {
          this.$message.error('获取工作台信息失败，请联系管理员')
          return
        }
        this.work.drawTaskBoList = res.result.drawTaskBoList
        this.work.completeUnDecryptTaskBoList = res.result.completeUnDecryptTaskBoList
        this.work.pendingExpertExtractTaskBoList = res.result.pendingExpertExtractTaskBoList
        this.work.pendingAuditApplyForTaskBoList = res.result.pendingAuditApplyForTaskBoList
        this.work.pendingAuditApplyForTaskTotal = res.result.pendingAuditApplyForTaskTotal || 0
        this.work.drawTaskTotal = res.result.drawTaskTotal || 0
      } catch (e) {
        this.$message.error(e.message)
      } finally {

      }
    },
    async getNearestExtractTaskList () {
      try {
        let res = await NearestExtractTaskList({ key: this.nearestDateQuery.key, ...this.page })
        if (200 !== res.code) {
          this.$message.error('获取最近任务，请联系管理员')
          return
        }
        this.work.nearestExtractTaskList = res.result
      } catch (e) {
        this.$message.error(e.message)
      } finally {
      }
    },
    //跳转页面
    goToUrl (url, id) {
      if (!url) {
        return
      }
      if (id) {
        this.$router.push({ path: url, query: { id: id } })
      } else {
        this.$router.push({ path: url })
      }
    },
    onAudit ({ id, applyForType }) {
      const visible = ApplyForTypeEnum.getAuditObj(applyForType).visible
      if (!visible) {
        this.$message.error('申请类型有误')
        return
      }
      if(this.$refs[visible]){
        this.$refs[visible].initData(id)
      }else{
        this.$error({
          title: '正在开发中...'
        })
      }
    }
  },
}
</script>

<style lang="less" scoped>

.ant-card-grid {
  padding: 20px;
}

.project-list {
  .card-title {
    font-size: 0;

    a {
      color: rgba(0, 0, 0, 0.85);
      margin-left: 12px;
      line-height: 24px;
      height: 24px;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;

      &:hover {
        color: #1890ff;
      }
    }
  }

  .card-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }

  .project-item {
    display: flex;
    margin-top: 8px;
    overflow: hidden;
    font-size: 12px;
    height: 20px;
    line-height: 20px;

    a {
      color: rgba(0, 0, 0, 0.45);
      display: inline-block;
      flex: 1 1 0;

      &:hover {
        color: #1890ff;
      }
    }

    .datetime {
      color: rgba(0, 0, 0, 0.25);
      flex: 0 0 auto;
      float: right;
    }
  }

  .ant-card-meta-description {
    color: rgba(0, 0, 0, 0.45);
    height: 44px;
    line-height: 22px;
    overflow: hidden;
  }
}

.item-group {
  padding: 20px 0 8px 24px;
  font-size: 0;

  a {
    color: rgba(0, 0, 0, 0.65);
    display: inline-block;
    font-size: 14px;
    margin-bottom: 13px;
    width: 25%;
  }
}

.members {
  a {
    display: block;
    margin: 12px 0;
    line-height: 24px;
    height: 24px;

    .member {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 24px;
      max-width: 100px;
      vertical-align: top;
      margin-left: 12px;
      transition: all 0.3s;
      display: inline-block;
    }

    &:hover {
      span {
        color: #1890ff;
      }
    }
  }
}

.limitHigh {
  color: red;
}

.limitMedium {
  color: #ff8000;
}

.p_12 {
  /deep/ .ant-card-body {
    padding: 0px 24px;
  }

  /deep/ .ant-spin-container {
    height: 437px;
  }

  /deep/ .ant-list-item-meta-content,
  /deep/ .ant-list-item-meta {
    overflow: hidden;
  }

  /deep/ .ant-list-item-meta-title {
    overflow: hidden;

    a {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
    }
  }
}

.font-weight-bold {
  font-weight: bold;
}
</style>
